export default "__VITE_PUBLIC_ASSET__4182e078__"